import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AppNav } from "@/components/AppNav";
import { API_URL } from "@/lib/supabase";

export const Route = createFileRoute("/verify-email")({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : "",
  }),
  head: () => ({ meta: [{ title: "Confirmar email — Busca Blindados" }] }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const { token } = Route.useSearch();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Link inválido.");
      return;
    }
    fetch(`${API_URL}/api/verify-email?token=${encodeURIComponent(token)}`)
      .then(async (res) => {
        if (res.ok) {
          setStatus("success");
        } else {
          const data = await res.json().catch(() => ({}));
          setStatus("error");
          setMessage((data as { error?: string }).error ?? "Link inválido ou expirado.");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Falha de conexão. Tente novamente.");
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-background">
      <AppNav />
      <div className="mx-auto max-w-md px-6 py-20 text-center">
        {status === "loading" && (
          <p className="text-muted-foreground">Verificando...</p>
        )}

        {status === "success" && (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-primary/40 bg-primary/10 text-primary text-xl">
              ✓
            </div>
            <h1 className="font-display text-2xl text-foreground">Email confirmado!</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Seus alertas estão ativos. Você receberá notificações quando encontrarmos carros no seu perfil.
            </p>
            <Link
              to="/alertas"
              className="btn-primary mt-6 inline-block rounded-full px-6 py-3 text-sm font-medium"
            >
              Ver meus alertas
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-red-500/20 bg-red-500/10 text-red-400 text-xl">
              ✕
            </div>
            <h1 className="font-display text-2xl text-foreground">Link inválido</h1>
            <p className="mt-2 text-sm text-muted-foreground">{message}</p>
            <Link to="/alertas" className="mt-6 inline-block text-sm text-primary hover:underline">
              Ir para minha conta
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
